<template>
    <div class="ttttt">
		<div class="footer">
			<!-- <div class="flo">查看更多</div> -->
			<div class="footTop page-content flexbetween">
				<div class="img">
					<img src="../../assets/image/logo.png" alt="">
				</div>
				<div class="beianh" @click="getbtn">备案号：豫ICP备20006643号-1</div>
				<div class="rightList flexbetween">
					<div class="child" v-for="(item,index) in list" @click="todetail(index)">{{item.name}}</div>
				</div>
			</div>
			<div class="footBot page-content flexleft">
				<div class="left">
					<img v-if="wxQrcodeUrls[0]" :src="$index.addurl(wxQrcodeUrls[0])" alt="">
					<div class="txt">微信公众号</div>
				</div>
				<div class="left" style="margin-left: 20px;">
					<img v-if="wxQrcodeUrls[1]" :src="$index.addurl(wxQrcodeUrls[1])" alt="">
					<div class="txt">微信视频号</div>
				</div>
				<div class="center">
					<div class="icon">
						<img src="../../assets/image/phone.png" alt="">
					</div>
					<div class="txt">免费服务热线</div>
					<div class="phone">{{data.telephone}}</div>
					<!-- <div class="bottxt">免费热线</div> -->
				</div>
				<div class="map animation-from-left-0">
					<el-amap ref="map" vid="amapDemo" :amap-manager="amapManager"
							:center="center"
							expandZoomRange="true"
							:zoom="zoom"
							:plugin="plugin"
							:pitch="66">
						<el-amap-marker
							vid="amapDemo"
							:position="center"
						  ></el-amap-marker>
					</el-amap>
				</div>
				<div class="right">
					<div class="icon flexbetween">
						<img src="../../assets/image/address.png" alt="">
					</div>
					<div class="txt">地址</div>
					<div class="address">{{data.address}}</div>
				</div>
			</div>
		</div>
    </div>
</template>
<script>
	import {amapManager} from 'vue-amap'
	export default {
		name: 'SiteFooter',
		data() {
			return {
				wxQrcodeUrls: ['', ''],
				amapManager,
				zoom: 12,
				center: [113.48218766864778 , 34.81196585552227 ],
				events: {
					init: (o) => {
					  o.getCity(result => {
						console.log(result,3)
					  })
					},
					'moveend': () => {
					},
					'zoomchange': () => {
					},
					'click': (e) => {
					  alert('map clicked');
					}
				},
				plugin: ['ToolBar', {
					pName: 'MapType',
					defaultType: 0,
					events: {
						init(o) {
							console.log(o);
						}
					}
				}],
				data:{
					
				},
			   list:[
					{
						name:'关于我们',
					}, {
						name:'创投服务'
					}, {
						name:'企业服务'
					},
					// {
					// 	name:'投教基地'
					// },
					{
						name:'政策资讯'
					},
					// {
					// 	name:'创投日报'
					// },
			   ],
			};
		},
		created() {
		  this.getdata();
		},
		methods: {
			getbtn(){
				window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank')
			},
			tomap(){
				window.open('http://m.amap.com/navigation/carmap/saddr=116.379028,39.865042,&daddr=116.427281,39.903719,&sort=dist');
			},
			getdata(){
				let _this = this;
				_this.$api.user.contactUs().then(res => {
					if(res.code == 1){
						_this.data = res.data;
						const jw = res.data.jwArr;
						if (jw && jw.length >= 2) {
							_this.center[0] = Number(jw[0]);
							_this.center[1] = Number(jw[1]);
						}
						const q = res.data.wxQrcode;
						if (Array.isArray(q)) {
							_this.wxQrcodeUrls = [q[0] || '', q[1] || ''];
						} else if (typeof q === 'string' && q) {
							const arr = q.split(',');
							_this.wxQrcodeUrls = [arr[0] || '', arr[1] || ''];
						} else {
							_this.wxQrcodeUrls = ['', ''];
						}
					}
				})
			},
			todetail(index){
				let _this = this;
				if(index == 0){
					_this.$router.push({name:'aboutus'})
				}else if(index==2){
					_this.$router.push({name:'fwTixi',query:{id:1}})
				}else if(index==1){
					_this.$router.push({name:'rzLiucheng',query:{id:2}})
				}else if(index==3){
					_this.$router.push({name:'policy'})
				}else if(index == 4){
					window.open('https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzU1NjcyNDU1OQ==&action=getalbum&album_id=2715355540427882498#wechat_redirect', '_blank');
					// _this.$router.push({name:'ctRibao'})
				}
				// ——以下为 list 中含「投教基地」时的分支索引（保留备查，勿删）——
				// }else if(index==3){
				// 	_this.$router.push({name:'study'})
				// }else if(index==4){
				// 	_this.$router.push({name:'policy'})
				// }else if(index == 5){
				// 	window.open('https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzU1NjcyNDU1OQ==&action=getalbum&album_id=2715355540427882498#wechat_redirect', '_blank');
				// }
			},
		},
		
	};
</script>

<style lang="scss" scoped>
	.map{
		position:absolute;
		top: 150px;
		right: 15%;
	}
	.footer{
		background-color: #153470;
		padding: 40px 0;
		position: relative;
		.flo{
			position: absolute;
			top: -56px;
			right: 14vw;
			background-color: #153470;
			font-size: 16px;
			padding: 16px 64px;
			color: #fff;
			letter-spacing: 2px;
		}
		.footTop{
			margin: 0 auto;
			padding-bottom: 40px;
			.img{
				width: 230px;
				height: 54px;
				img{
					object-fit: fill;
					width: 100%;
					height: 100%;
				}
			}
			.beianh{
				color: #fff;
				font-size:14px;
				cursor: pointer;
				margin: 0 100px;
			}
			.rightList{
				flex-grow: 1;
				.child{
					flex-grow: 1;
					cursor: pointer;
					font-family: MicrosoftYaHeiLight;
					font-size: 14px;
					letter-spacing: 1px;
					color: #ffffff;
					text-align: center;
				}
			}
		
		}
		.footBot{
			margin: 0 auto;
			padding: 20px 0;
			border-bottom: 1px solid #3B5485;
			border-top: 1px solid #3B5485;
			align-items: flex-start;
			.left{
				border: 2px solid #2F4A7B;
				padding: 15px 15px 10px 15px;
				img{
					width: 87px;
					height: 87px;
				}
				.txt{
					font-size: 14px;
					color: #fff;
					text-align: center;
				}
			}
			.center{
				margin: 0 30px;
				.icon{
					padding: 10px;
					border-radius: 50%;
					border: 1px solid #2F508A;
					width: 50px;
					height: 50px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.txt{
					font-size: 14px;
					color: #b5c0d4;
					margin-top: 10px;
				}
				.phone{
					font-family: MicrosoftYaHei-Bold;
					font-size: 40px;
					letter-spacing: 2px;
					color: #b5c0d4;
					font-weight: bold;
				}
				.bottxt{
					font-size: 14px;
					color: #b5c0d4;
				}
			}
			.right{
				.icon{
					padding: 10px;
					border-radius: 50%;
					border: 1px solid #2F508A;
					width: 50px;
					height: 50px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.txt{
					font-size: 14px;
					color: #b5c0d4;
					margin-top: 10px;
				}
				.address{
					font-size: 14px;
					color: #b5c0d4;
					margin-top: 16px;
					width: 300px;
				}
			}
		
		}
	
	}

</style>



// WEBPACK FOOTER //
// footer.vue?6856bf7e